import {
    bl_fi_generic_doc_hdr_RowClass,
    bl_fi_generic_doc_hdr_RowInterface,
    bl_fi_generic_doc_line_RowClass
} from "../../../../models";

export class GenDocMultiPoDTO {
  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowInterface =
    new bl_fi_generic_doc_hdr_RowClass();
  bl_fi_generic_doc_line: bl_fi_generic_doc_line_RowClass[] = [];
  code: string;
  name: string;
  location_guids: string[] = [];
}
